<template>
  <v-layout row wrap>
    <v-flex xs5>
      <v-text-field v-model="contactName" label="Contact Name" :rules="fieldRules" required hint="Required" persistent-hint></v-text-field>
      <v-text-field v-model="contactEmail" label="Contact Email"></v-text-field>
      <v-text-field v-model="contactPhone" label="Contact Phone"></v-text-field>
    </v-flex>

    <v-flex xs1></v-flex>

    <v-flex xs5>
      <v-text-field v-model="shippingLine1" label="Shipping Address Street" :rules="fieldRules" required hint="Required" persistent-hint></v-text-field>
      <v-text-field v-model="shippingLine2" label="Shipping Address"></v-text-field>
      <v-text-field v-model="shippingCity" label="Shipping City"></v-text-field>
      <v-text-field v-model="shippingState" label="Shipping County"></v-text-field>
      <v-text-field v-model="shippingPostCode" label="Shipping Post Code"></v-text-field>
      <v-select
        v-model="shippingCountry"
        :items="countries"
        item-text="description"
        item-value="country"
        label="Shipping Country"
        single-line
      ></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderDetailCardBrands',
  data () {
    return {
      fieldRules: [v => !!v || 'This information is required'],
      countries: [
        { country: 'uk', description: 'United Kingdom' },
        { country: 'roi', description: 'Republic of Ireland' },
        { country: 'ni', description: 'Northern Ireland' }
      ]
    }
  },
  computed: {
    contactName: {
      get () { return this.$store.state.order.contactName },
      set (value) { this.$store.commit('updateOrder', ['contactName', value]) }
    },
    contactEmail: {
      get () { return this.$store.state.order.contactEmail },
      set (value) { this.$store.commit('updateOrder', ['contactEmail', value]) }
    },
    contactPhone: {
      get () { return this.$store.state.order.contactPhone },
      set (value) { this.$store.commit('updateOrder', ['contactPhone', value]) }
    },
    shippingLine1: {
      get () { return this.$store.state.order.shippingLine1 },
      set (value) { this.$store.commit('updateOrder', ['shippingLine1', value]) }
    },
    shippingLine2: {
      get () { return this.$store.state.order.shippingLine2 },
      set (value) { this.$store.commit('updateOrder', ['shippingLine2', value]) }
    },
    shippingCity: {
      get () { return this.$store.state.order.shippingCity },
      set (value) { this.$store.commit('updateOrder', ['shippingCity', value]) }
    },
    shippingState: {
      get () { return this.$store.state.order.shippingState },
      set (value) { this.$store.commit('updateOrder', ['shippingState', value]) }
    },
    shippingPostCode: {
      get () { return this.$store.state.order.shippingPostCode },
      set (value) { this.$store.commit('updateOrder', ['shippingPostCode', value]) }
    },
    shippingCountry: {
      get () { return this.$store.state.order.shippingCountry },
      set (value) { this.$store.commit('updateOrder', ['shippingCountry', value]) }
    }
  }
}
</script>

<style scoped>

</style>
